<!-- <nz-divider nzText="Plans" nzOrientation="left"></nz-divider> -->


<!-- <label *ngFor="let plan of plans ; let i = index" 
[ngClass]="{ 'padding-left-10px': i === 0 }"  nz-checkbox [(ngModel)]="plan.isChecked"
(ngModelChange)="onPlanChange(plan)">
  {{plan.planName}}
</label>
 -->
 <!-- (nzOpenChange)="loadPlans()" -->
 <!-- (nzFocus)="loadPlans(false)" -->

<nz-select (ngModelChange)="onPlanChange($event)"
(nzOpenChange)="loadPlans(false)"
 [nzMaxTagCount]="1" nzShowSearch nzMode="multiple" nzAllowClear nzPlaceHolder="Select a plan"
  [(ngModel)]="selectedValue"
  [nzLoading]="isLoading"
  >
  <nz-option *ngFor="let plan of plans" [nzLabel]="plan.planName" [nzValue]="plan.planId"></nz-option>
</nz-select>

<label class="mr-l" nz-checkbox 
[(ngModel)]="isCheckedAllPlans"
[nzDisabled]="isDisabledButton"
(ngModelChange)="onChecked()"
>All</label> 